import { render, staticRenderFns } from "./TripInbound.vue?vue&type=template&id=73aa3f01"
import script from "./TripInbound.vue?vue&type=script&lang=js"
export * from "./TripInbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports